// src/pages/UpSarpanchKaryalaya.js
import React from "react";

const Upsarpanch = () => {
  const currentDate = new Date().toLocaleDateString("en-IN");
  const currentTime = new Date().toLocaleTimeString("en-IN");

  return (
    <div style={styles.container}>
      {/* ===== Header ===== */}
      <header style={styles.header}>
        <div style={styles.logo}>
          <div style={styles.logoCircle}>GP</div>
        </div>
        <div style={styles.title}>
          <h1 style={styles.mainTitle}>ग्रामपंचायत </h1>
          <p style={styles.subTitle}>पंचायत समिती अंबरनाथ| जिल्हा परिषद ठाणे</p>
          <p style={styles.timestamp}>अद्ययावत: {currentDate} | वेळ: {currentTime}</p>
        </div>
      </header>

      {/* ===== उपसरपंच प्रोफाईल (फोटोसह) ===== */}
      <section style={styles.profileSection}>
        <div style={styles.profileCard}>
          {/* फोटो जोडला */}
          <div style={styles.photoContainer}>
            <img
              src={`${process.env.PUBLIC_URL}/images/upsarpanch.jpeg`}
              alt="सन्माननीय उपसरपंच सौ..नीलिमा योगेश माढवी "
              style={styles.upsarpanchPhoto}
            />
          </div>
          <div style={styles.profileInfo}>
            <h2 style={styles.upsarpanchName}>
              सन्माननीय उपसरपंच:श्री. विशाल शंकर पाटील      
            </h2>
            <p style={styles.motto}>
              <strong>‘तुमचा अनुभव, माझ्या कामाची दिशा’</strong>
              <h6>phone no :8468915692 </h6>
            </p>
          </div>
        </div>
      </section>

      {/* ===== संदेश ===== */}
      <section style={styles.messageSection}>
        <h3 style={styles.sectionTitle}>उपसरपंचांचा संदेश</h3>
        <p style={styles.message}>
          मी, <strong> श्री. विशाल शंकर पाटील </strong>,  ग्रामपंचायत उसाटणे  गावकऱ्यांशी <strong>सतत संवाद साधण्यावर</strong> विश्वास ठेवतो. उपसरपंच म्हणून, माझी जबाबदारी केवळ प्रशासकीय कामे पाहण्याची नाही, तर <em>प्रत्येक वयोगटातील नागरिकाच्या समस्या समजून घेऊन त्या सोडवण्याची</em> आहे.
        </p>
      </section>

      {/* ===== लोकसंपर्क आणि संवाद ===== */}
      <section style={styles.contactSection}>
        <h3 style={styles.sectionTitle}>लोकसंपर्क आणि संवाद</h3>
        <p style={styles.intro}>
          मी गावकऱ्यांच्या सूचना आणि अडचणी थेट जाणून घेण्यासाठी खालील बाबींवर विशेष लक्ष देतो:
        </p>
        <div style={styles.contactGrid}>
          <div style={styles.contactCard}>
            <span style={styles.icon}>Group</span>
            <h4>सामाजिक बैठका</h4>
            <p>महिला मंडळे, युवक गट आणि ज्येष्ठ नागरिकांच्या बैठकांना नियमित उपस्थिती आणि सूचनांचा विकास आराखड्यात समावेश.</p>
          </div>
          <div style={styles.contactCard}>
            <span style={styles.icon}>Support</span>
            <h4>तक्रार निवारण</h4>
            <p>तक्रारींचा पाठपुरावा आणि तक्रारदाराला कामाच्या प्रगतीबद्दल वेळेत माहिती देणे.</p>
          </div>
          <div style={styles.contactCard}>
            <span style={styles.icon}>Info</span>
            <h4>शासकीय योजनांची माहिती</h4>
            <p>सरपंचांच्या मार्गदर्शनाखाली प्रत्येक कुटुंबाला शासकीय योजनांची सविस्तर माहिती मिळेल याची व्यवस्था.</p>
          </div>
        </div>
      </section>

      {/* ===== शिकवण आणि भविष्याची दृष्टी ===== */}
      <section style={styles.visionSection}>
        <h3 style={styles.sectionTitle}>शिकवण आणि भविष्याची दृष्टी</h3>
        <p style={styles.visionText}>
          सरपंचांसोबत काम करताना मिळालेल्या अनुभवाचा वापर मी गावाच्या विकासासाठी एक <strong>भविष्यकालीन योजना</strong> तयार करण्यासाठी करतो. मी सतत उत्तम प्रशासनाचे नवीन मार्ग शिकत असतो आणि <strong>  उसाटणे  अधिक स्मार्ट आणि कार्यक्षम ग्रामपंचायत</strong> बनवण्यासाठी प्रयत्नशील असतो.
        </p>
      </section>

      {/* ===== समाप्ती संदेश ===== */}
      <section style={styles.closingSection}>
        <p style={styles.closing}>
          <strong>आम्ही (उपसरपंच म्हणून) सरपंच आणि सर्व सदस्यांसोबत,   उसाटणे महाराष्ट्रातील एक आदर्श गाव बनवण्याचा संकल्प केला आहे!</strong>
        </p>
      </section>

      {/* ===== फूटर ===== */}
      <footer style={styles.footer}>
        <p>© 2026 ग्रामपंचायत उसाटणे | सर्व हक्क राखीव</p>
        <p>वेबसाइट: <a href="https://usatane.in" style={styles.link}>gpusatane</a></p>
      </footer>
    </div>
  );
};

// ====== Internal CSS (Updated with Photo) ======
const styles = {
  container: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    maxWidth: "900px",
    margin: "20px auto",
    padding: "20px",
    background: "#f8fdff",
    border: "2px solid #1d649eff",
    borderRadius: "16px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    color: "#333",
  },
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "3px solid #1a4083ff",
    paddingBottom: "15px",
    marginBottom: "25px",
  },
  logo: {
    marginRight: "15px",
  },
  logoCircle: {
    width: "70px",
    height: "70px",
    background: "#1a4083ff",
    color: "white",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    fontWeight: "bold",
  },
  title: {
    flex: 1,
  },
  mainTitle: {
    margin: 0,
    fontSize: "26px",
    color: "#1a4083ff",
    fontWeight: "bold",
  },
  subTitle: {
    margin: "5px 0",
    fontSize: "16px",
    color: "#555",
  },
  timestamp: {
    margin: "5px 0",
    fontSize: "14px",
    color: "#c62828",
    fontWeight: "bold",
  },

  // फोटो स्टाइल
  profileSection: {
    marginBottom: "30px",
  },
  profileCard: {
    display: "flex",
    alignItems: "center",
    background: "linear-gradient(135deg, #e8f5e9, #c8e6c9)",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  photoContainer: {
    marginRight: "20px",
  },
  upsarpanchPhoto: {
    width: "130px",
    height: "130px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "5px solid white",
    boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
  },
  profileInfo: {
    flex: 1,
  },
  upsarpanchName: {
    margin: "0 0 10px 0",
    fontSize: "22px",
    color: "#1a4083ff",
    fontWeight: "bold",
  },
  motto: {
    margin: 0,
    fontSize: "18px",
    fontStyle: "italic",
    color: "#1a4083ff",
  },

  messageSection: {
    marginBottom: "30px",
    background: "#ffffff",
    padding: "20px",
    borderRadius: "10px",
    borderLeft: "5px solid #1a4083ff",
  },
  sectionTitle: {
    color: "#1a4083ff",
    borderBottom: "2px solid #1a4083ff",
    paddingBottom: "8px",
    marginTop: 0,
    marginBottom: "15px",
    fontSize: "20px",
  },
  message: {
    fontSize: "16px",
    lineHeight: "1.7",
    margin: 0,
  },
  contactSection: {
    marginBottom: "30px",
  },
  intro: {
    marginBottom: "20px",
    fontSize: "16px",
  },
  contactGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "15px",
  },
  contactCard: {
    background: "#e8f5e9",
    padding: "15px",
    borderRadius: "10px",
    border: "1px solid #1a4083ff",
    textAlign: "center",
  },
  icon: {
    fontSize: "32px",
    display: "block",
    marginBottom: "10px",
  },
  visionSection: {
    marginBottom: "30px",
    background: "#f1f8e9",
    padding: "20px",
    borderRadius: "10px",
    border: "1px dashed #1a4083ff",
  },
  visionText: {
    fontSize: "16px",
    lineHeight: "1.7",
    margin: 0,
  },
  closingSection: {
    background: "linear-gradient(135deg, #e8f5e9, #c8e6c9)",
    padding: "25px",
    borderRadius: "12px",
    textAlign: "center",
    marginBottom: "30px",
    border: "2px dashed #1a4083ff",
  },
  closing: {
    fontSize: "18px",
    lineHeight: "1.8",
    margin: 0,
    color: "#1a4083ff",
    fontWeight: "bold",
  },
  footer: {
    textAlign: "center",
    paddingTop: "20px",
    borderTop: "1px solid #ddd",
    fontSize: "14px",
    color: "#666",
  },
  link: {
    color: "#1a4083ff",
    textDecoration: "none",
  },
};

export default Upsarpanch;